import { render, staticRenderFns } from "./SettingEmail.vue?vue&type=template&id=20a8b018&scoped=true"
import script from "./SettingEmail.vue?vue&type=script&lang=js"
export * from "./SettingEmail.vue?vue&type=script&lang=js"
import style0 from "./SettingEmail.vue?vue&type=style&index=0&id=20a8b018&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a8b018",
  null
  
)

export default component.exports